import { render, staticRenderFns } from "./devicePeport.vue?vue&type=template&id=08957a2c&scoped=true"
import script from "./devicePeport.vue?vue&type=script&lang=js"
export * from "./devicePeport.vue?vue&type=script&lang=js"
import style0 from "./devicePeport.vue?vue&type=style&index=0&id=08957a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08957a2c",
  null
  
)

export default component.exports